import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../services/api';

export function useCorrelationRulesQuery(
  tenantId: string,
  params?: { isEnabled?: boolean; correlationType?: string },
) {
  return useQuery({
    queryKey: ['correlation-rules', tenantId, params],
    queryFn: () => apiClient.getCorrelationRules(tenantId, params),
    enabled: !!tenantId,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}

export function useCorrelationRuleQuery(tenantId: string, id: string) {
  return useQuery({
    queryKey: ['correlation-rules', tenantId, id],
    queryFn: () => apiClient.getCorrelationRule(tenantId, id),
    enabled: !!tenantId && !!id,
  });
}
